import React, { useLayoutEffect } from "react";

import { getPhoneNumber } from "../services/utils";

export default function CtmPhone({ underlined = true }) {
  const [phone, phoneFull, replacePhoneCTM] = getPhoneNumber();

  useLayoutEffect(() => {
    replacePhoneCTM();
  }, []);

  return (
    <a className={`${underlined ? "underline" : ""}`} href={`tel:${phoneFull}`}>
      {phone}
    </a>
  );
}
